import { API_GET_SOURCE_RATING } from "@/config/api.config";
import apiCall from "@/utils/api";
import downloadFile from "@/utils/file";

export const FETCH_SOURCE_RATING = "FETCH_SOURCE_RATING";
export const FETCH_SOURCE_RATING_FILE = "FETCH_SOURCE_RATING_FILE";
export const SET_SOURCE_RATING = "SET_SOURCE_RATING";

export default {
  [FETCH_SOURCE_RATING]({ commit }, { params } = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    return apiCall({
      method: API_GET_SOURCE_RATING,
      params,
    })
      .then(({ status, data }) => {
        if (status === 200 && !data.error) {
          commit(SET_SOURCE_RATING, data.data);
          return data;
        }
        throw data;
      })
      .catch((error) => {
        commit("SET_ERROR", error.details || error.message);
        throw error;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },

  [FETCH_SOURCE_RATING_FILE](_, params = {}) {
    return downloadFile({
      method: API_GET_SOURCE_RATING,
      params: { ...params, format: "excel" },
    });
  },
};
